__turbopack_context__.v({
  "container": "ItemListContainer-module-scss-module__5ebbRW__container",
  "list": "ItemListContainer-module-scss-module__5ebbRW__list",
  "search-expansion-container": "ItemListContainer-module-scss-module__5ebbRW__search-expansion-container",
  "search-expansion-container--zero-results": "ItemListContainer-module-scss-module__5ebbRW__search-expansion-container--zero-results",
});
